import libjpegTurboFactory from '@cornerstonejs/codec-libjpeg-turbo-8bit/decodewasmjs';
const libjpegTurboWasm = new URL('@cornerstonejs/codec-libjpeg-turbo-8bit/decodewasm', import.meta.url);
import getPixelData from './getPixelData.js';
import { resolveWasmUrl, setWasmBasePathFromConfig } from '../wasmBasePath.js';
const local = {
    codec: undefined,
    decoder: undefined,
};
function initLibjpegTurbo(decodeConfig) {
    setWasmBasePathFromConfig(decodeConfig);
    if (local.codec) {
        return Promise.resolve();
    }
    const libjpegTurboModule = libjpegTurboFactory({
        locateFile: (f) => {
            if (f.endsWith('.wasm')) {
                return resolveWasmUrl('libjpegturbowasm_decode.wasm', libjpegTurboWasm);
            }
            return f;
        },
    });
    return new Promise((resolve, reject) => {
        libjpegTurboModule.then((instance) => {
            local.codec = instance;
            local.decoder = new instance.JPEGDecoder();
            resolve();
        }, reject);
    });
}
async function decodeAsync(compressedImageFrame, imageInfo) {
    await initLibjpegTurbo();
    const decoder = local.decoder;
    const encodedBufferInWASM = decoder.getEncodedBuffer(compressedImageFrame.length);
    encodedBufferInWASM.set(compressedImageFrame);
    decoder.decode();
    const frameInfo = decoder.getFrameInfo();
    const decodedPixelsInWASM = decoder.getDecodedBuffer();
    const encodedImageInfo = {
        columns: frameInfo.width,
        rows: frameInfo.height,
        bitsPerPixel: frameInfo.bitsPerSample,
        signed: imageInfo.signed,
        bytesPerPixel: imageInfo.bytesPerPixel,
        componentsPerPixel: frameInfo.componentCount,
    };
    const pixelData = getPixelData(frameInfo, decodedPixelsInWASM);
    const encodeOptions = {
        frameInfo,
    };
    return {
        ...imageInfo,
        pixelData,
        imageInfo: encodedImageInfo,
        encodeOptions,
        ...encodeOptions,
        ...encodedImageInfo,
    };
}
const initialize = initLibjpegTurbo;
export { initialize };
export default decodeAsync;
